export default {
  props: {
    hasPopup: {
      type: Boolean,
      default: undefined,
    },
    popupBackground: {
      type: String,
      default: undefined,
    },
    popupCtaLabel: {
      type: String,
      default: undefined,
    },
    popupCtaLeftIcon: {
      type: String,
      default: undefined,
    },
    popupCtaRightIcon: {
      type: String,
      default: undefined,
    },
    popupCtaLeftIconEnabled: {
      type: Boolean,
      default: undefined,
    },
    popupCtaRightIconEnabled: {
      type: Boolean,
      default: undefined,
    },
    popupHeader: {
      type: String,
      default: undefined,
    },
    popupHeaderTextSize: {
      type: Number,
      default: undefined,
    },
    popupHeaderTextColor: {
      type: String,
      default: undefined,
    },
    popupHeaderIconColor: {
      type: String,
      default: undefined,
    },
  },
};
